import BankAccountsPage from "./BankAccountsPage";

export default BankAccountsPage;
